import { useCallback } from 'react';
import html2pdf from 'html2pdf.js';
import { callApi } from '../api/callApi';
import { API_ENDPOINT, API_URL_ORDER_SERVICE } from '../api/constant';

const useDownloadInvoice = () => {
  const downloadInvoice = useCallback(async (orderId: string) => {
    try {
      const html = await callApi(
        `${API_URL_ORDER_SERVICE}${API_ENDPOINT.order}/invoice/${orderId}`,
        { method: 'GET', responseType: 'text' },
      );

      const element = document.createElement('div');
      element.innerHTML = html;

      const opt = {
        margin: 0,
        filename: `invoice-${orderId}.pdf`,
        image: { type: 'jpeg' as const, quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: {
          unit: 'mm' as const,
          format: 'a4' as const,
          orientation: 'portrait' as const,
          compress: true,
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      };

      const pdfBlob = await html2pdf().set(opt).from(element).output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      setTimeout(() => URL.revokeObjectURL(pdfUrl), 60000);
    } catch (err) {
      console.error('Error loading invoice:', err);
    }
  }, []);

  return { downloadInvoice };
};

export default useDownloadInvoice;
